module.exports = __webpack_public_path__ + "static/device01-b8cd29b41f67602f37eb6fe07bcbb7b0.jpg";